import { Link } from "react-router-dom";
import { useLang } from "../context/LangContext";
import { pick } from "../i18n/strings";

function fmtDate(iso, lang) {
  try {
    return new Date(iso).toLocaleDateString(
      lang === "ca" ? "ca-ES" : lang === "en" ? "en-GB" : "es-ES",
      { day: "2-digit", month: "long", year: "numeric" },
    );
  } catch {
    return iso;
  }
}

export function ExperienceCard({ exp }) {
  const { lang, t } = useLang();
  const soldOut = !!exp.sold_out;
  return (
    <Link
      to={`/experiences/${exp.id}`}
      data-testid={`exp-card-${exp.id}`}
      className="group block"
    >
      <div className="relative overflow-hidden rounded-2xl aspect-[4/5] bg-brand-ivory">
        <img
          src={exp.image}
          alt={pick(exp.title, lang)}
          className={`h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105 ${soldOut ? "grayscale-[35%]" : ""}`}
          loading="lazy"
        />
        <div className="absolute top-3 left-3 text-brand-cream">
          <span className="inline-block px-2.5 py-1 rounded-full bg-brand-brown/70 backdrop-blur text-[10px] tracking-[0.25em] font-bold uppercase">
            {t("chapter")} {exp.chapter}
          </span>
        </div>
        {soldOut && (
          <div className="absolute top-3 right-3">
            <span
              className="inline-block px-3 py-1 rounded-full bg-brand-cream text-brand-brown text-[10px] tracking-[0.3em] font-bold uppercase shadow-sm"
              data-testid={`exp-sold-out-${exp.id}`}
            >
              {t("sold_out")}
            </span>
          </div>
        )}
        <div className="absolute bottom-0 inset-x-0 h-1/2 bg-gradient-to-t from-black/55 to-transparent" />
        <div className="absolute bottom-3 left-3 right-3 text-brand-cream">
          <p className="text-[10px] tracking-[0.3em] uppercase opacity-80">
            {fmtDate(exp.date, lang)}
          </p>
          <h3 className="font-serif text-2xl leading-tight mt-1">
            {pick(exp.title, lang)}
          </h3>
        </div>
      </div>
      <div className="flex items-center justify-between pt-3 px-1">
        <p className="text-xs tracking-[0.22em] uppercase font-bold text-brand-tan">
          {exp.location}
        </p>
        <p className="text-sm font-bold text-brand-brown">
          {soldOut ? t("sold_out") : `${t("from_price")} · €${exp.price_eur}`}
        </p>
      </div>
    </Link>
  );
}

export default ExperienceCard;
